import React, { useState } from 'react';
import { LabelAndCheckboxContainer, ErrorText } from './styles';
import { Button } from 'components/Button/RoundButton';
import { OuterContainer, SectionTitle, TextInput, Label } from '../styles';

export const AutoArchiveTests = ({ archiveTest, updateConfig }) => {
  const [autoArchiveTestObject, setAutoArchiveTestObject] = useState(JSON.parse(JSON.stringify(archiveTest)));
  const [error, setError] = useState('');

  return (
    <OuterContainer>
      <SectionTitle>Tests</SectionTitle>
      <LabelAndCheckboxContainer>
        <TextInput
          type="number"
          min="1"
          padding="5px"
          margin="0px"
          height="30px"
          width="45px"
          onChange={(e) => {
            let copyOfArchivedTestObject = { ...autoArchiveTestObject };
            copyOfArchivedTestObject.value = e.target.value;
            setAutoArchiveTestObject(copyOfArchivedTestObject);
          }}
          value={autoArchiveTestObject.value}
        />
        <Label isInputNumberLabel>Auto archive test (in weeks)</Label>
      </LabelAndCheckboxContainer>
      {error && <ErrorText>{error}</ErrorText>}
      <Button
        small
        primaryBlue
        primaryGreenBorder
        removeMargin
        margin="15px 0 0 0px"
        onClick={() => {
          if (autoArchiveTestObject.value < 1) return setError('Value should be greater than 1');
          setError('');
          updateConfig(autoArchiveTestObject._id, { value: autoArchiveTestObject.value });
        }}
      >
        Save
      </Button>
    </OuterContainer>
  );
};
